import {
  createMutationHookObject,
  GetMutationParams,
  GetMutationResults,
  Mutations,
} from 'entities/hooks';

import { teamMutations } from './teams';
import { userMutations } from './users';
import { officeMutations } from './offices';
import { projectMutations } from './projects';
import { authMutations } from './auth';
import { clientMutations } from './clients';
import { notificationsMutations } from './notification';

import { invoiceMutations } from './invoice';
import { outsourceProviderMutations } from './outsourceProviders';
import { uploadMutations } from './uploads';
import { feedbackMutations } from './feedback';

// enforce intellisense and permission <> key
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildMutations<AppMutations extends Record<string, Mutations<any>>>(
  mutations: AppMutations,
): AppMutations {
  return mutations;
}

export const entityMutations = buildMutations({
  auth: authMutations,

  teams: teamMutations,

  users: userMutations,

  offices: officeMutations,

  projects: projectMutations,

  clients: clientMutations,

  invoice: invoiceMutations,

  notifications: notificationsMutations,

  outsourceProviders: outsourceProviderMutations,

  uploads: uploadMutations,

  feedback: feedbackMutations,
});

export type EntityMutations = typeof entityMutations;

export type MutationParams = GetMutationParams<EntityMutations>;
export type MutationResults = GetMutationResults<EntityMutations>;

export const actions = createMutationHookObject(entityMutations);
